import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const BadgeListWidget: WidgetRegistryEntry = {
  name: "BadgeList",
  configuration: () => import("./configuration").then((m) => m.BadgeListWidgetConfiguration),
  component: () => import("./badge-list-widget.component").then((m) => m.BadgeListWidgetComponent)
};
